module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/20-0b4198d40ceab72b1b81336c1d34458a.jpg";